// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3vfpl","title":"ClientInsurance_title__9ktS8","itemText":"ClientInsurance_itemText__3rtdi"};